<div class="p-20">
  <mat-card class="example-card mat-elevation-z4 mb-20" *ngFor="let categoria of categorias">
    <mat-card-header>
      <mat-card-title>{{'COLABORADORES.ACCIONES.TITULO' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="w100" fxLayout="row" fxLayoutAlign="space-evenly center">
        <ng-container *ngFor="let accion of categoria.acciones; let last = last;">
          <div fxLayout="column" fxLayoutAlign="start center" fxFlex="15">
            <button mat-mini-fab color="primary" [disabled]="accion.bloqueado" (click)="this[accion.funcion]()">
              <mat-icon>{{accion.icono}}</mat-icon>
            </button>
            <em class="nomBoton">{{'COLABORADORES.ACCIONES.LISTA.' + accion.id | translate}}</em>
          </div>
          <mat-divider [vertical]="true" *ngIf="!last"></mat-divider>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-horizontal-stepper [(selectedIndex)]="pasoColaboradores" #stepper>
    <mat-step>
      <div *ngIf="cargandoColaboradores" fxLayout="column" fxLayoutAlign="start center" class="p-20">
        <p>{{'COLABORADORES.CARGANDO' | translate}}</p>
        <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      </div>
      <ng-container *ngIf="resultados">
        <ng-container *ngIf="resultados.filteredData.length > 0">
          <h2>{{'COLABORADORES.TABLA.TITULO' | translate}}</h2>
          <table mat-table [dataSource]="resultados" class="w100">

            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>{{'COLABORADORES.TABLA.COLUMNAS.NOMBRE' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                {{colaborador.name}}
              </td>
            </ng-container>

            <ng-container matColumnDef="correo">
              <th mat-header-cell *matHeaderCellDef>{{'COLABORADORES.TABLA.COLUMNAS.EMAIL' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                {{colaborador.email}}
              </td>
            </ng-container>

            <ng-container matColumnDef="clave">
              <th mat-header-cell *matHeaderCellDef>{{'COLABORADORES.TABLA.COLUMNAS.PASS' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                <button mat-stroked-button fxFlex class="botClave" (click)="copiarURL(colaborador.password)">
                  {{colaborador.password}}
                  <mat-icon class="ml-10">file_copy</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>{{'COLABORADORES.TABLA.COLUMNAS.STATUS' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                <ng-container [ngSwitch]="colaborador.id_status">
                  <ng-container *ngSwitchCase="'1'">
                    {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO1' | translate}}
                  </ng-container>
                  <ng-container *ngSwitchCase="'2'">
                    {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO2' | translate}}
                  </ng-container>
                  <ng-container *ngSwitchCase="'3'">
                    {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO3' | translate}}
                  </ng-container>
                  <ng-container *ngSwitchCase="'4'">
                    {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO4' | translate}}
                  </ng-container>
                  <ng-container *ngSwitchCase="'5'">
                    {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO5' | translate}}
                  </ng-container>
                  <ng-container *ngSwitchCase="'6'">
                    {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO6' | translate}}
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="inicio">
              <th mat-header-cell *matHeaderCellDef>{{'COLABORADORES.TABLA.COLUMNAS.FECHA_INI' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                <ng-container [ngSwitch]="colaborador.start_date">
                  <ng-container *ngSwitchCase="null">
                    {{'COLABORADORES.TABLA.NOINFO' | translate}}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{colaborador.start_date | date:"d MMM y H:mm": datosEmpresaProducto.offsetPipe : idiomaActual}} ({{colaborador.start_date |date:'O': datosEmpresaProducto.offsetPipe : idiomaActual}})
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="fin">
              <th mat-header-cell *matHeaderCellDef>{{'COLABORADORES.TABLA.COLUMNAS.FECHA_FIN' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                <ng-container [ngSwitch]="colaborador.end_date">
                  <ng-container *ngSwitchCase="null">
                    {{'COLABORADORES.TABLA.NOINFO' | translate}}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{colaborador.end_date | date:"d MMM y H:mm": datosEmpresaProducto.offsetPipe : idiomaActual}} ({{colaborador.end_date |date:'O': datosEmpresaProducto.offsetPipe : idiomaActual}})
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>{{'COLABORADORES.TABLA.COLUMNAS.ACCIONES' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                <button color="primary" class="m-5" mat-mini-fab matTooltip="{{'COLABORADORES.TABLA.TOOLTIPS.ACCIONES' | translate}}" [matTooltipPosition]="'below'" (click)="accionesUsuario(colaborador)">
                  <mat-icon>settings</mat-icon>
                </button>
                <button color="primary" class="m-5" mat-mini-fab matTooltip="{{'COLABORADORES.TABLA.TOOLTIPS.EMAILS' | translate}}" [matTooltipPosition]="'below'" (click)="verCorreos(colaborador)" [disabled]="colaborador.sinCorreos">
                  <mat-icon>email</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnasResultado"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasResultado;"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
        </ng-container>
      </ng-container>
    </mat-step>
    <mat-step>
      <div class="w100" fxLayout="column" fxLayoutAlign="start stretch">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'COLABORADORES.SENDGRID.TITULO' | translate}}</h2>
          <button mat-stroked-button (click)="pasoColaboradores = 0">
            <mat-icon>arrow_back</mat-icon>
            <span class="ml-10">{{'COLABORADORES.SENDGRID.BOTONES.BACK' | translate}}</span>
          </button>
        </div>
        <p>{{'COLABORADORES.SENDGRID.SUBTITULO' | translate}}</p>
        <!-- <div class=""fxLayout="row" >
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Seleccione un Idioma</mat-label>
            <mat-select [(ngModel)]="tipoIdiomaElgido" (selectionChange)="eligeIdiomaLog($event)">
              <mat-option *ngFor="let lang of idiomasTemplateEmail" [value]="lang">
                {{'SELECTOR.'+lang.idioma | translate}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{'COLABORADORES.SENDGRID.SELOPC' | translate}}</mat-label>
            <mat-select [(ngModel)]="tipoAsuntoElgido" (selectionChange)="eligeAsuntoLog()" >
              <mat-option *ngFor="let asunto of informacionTemplateSelect" [value]="asunto">
                {{asunto.asunto}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        <!-- </div> -->
        <ng-container *ngIf="tipoAsuntoElgido">
          <ng-container *ngIf="cargaCorreos">
            <mat-card class="example-card mat-elevation-z4 mb-20" *ngIf="correosPrueba.length > 0">
              <mat-card-header>
                <mat-card-subtitle>{{'COLABORADORES.SENDGRID.INFOASUNTO.TITULO' | translate}}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <ul>
                  <li><b>{{'COLABORADORES.SENDGRID.INFOASUNTO.CARD.from' | translate}}: </b>{{colaboradorSeleccionado.email}}</li>
                  <li><b>{{'COLABORADORES.SENDGRID.INFOASUNTO.CARD.to' | translate}}: </b>{{correosPrueba[0].from_email}}</li>
                  <li><b>{{'COLABORADORES.SENDGRID.INFOASUNTO.CARD.subject' | translate}}: </b>{{tipoAsuntoElgido.asunto}}</li>
                </ul>
              </mat-card-content>
            </mat-card>
            <ng-container *ngIf="correosPrueba.length > 0; else sinCorreos">
              <h2>{{'COLABORADORES.SENDGRID.INFOASUNTO.HISTORIAL.TITULO' | translate}}</h2>
              <p><em>{{'COLABORADORES.SENDGRID.INFOASUNTO.HISTORIAL.SUBTITULO' | translate}} {{'TOOLBAR.CITIES.'+datosEmpresaProducto.indiceZona | translate}}</em></p>
              <mat-list>
                <ng-container *ngFor="let correo of correosPrueba; let last = last;">
                  <mat-list-item class="hta">
                    <div class="w100" fxLayout="row" fxLayoutAlign="center center">
                      <div fxLayout="row" fxLayoutAlign="space-between center" class="w70 ptb-10" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                        <div fxLayout="column" fxLayoutAlign="start stretch" class="status mr-20" fxFlex>
                          <p class="m-0">{{'COLABORADORES.SENDGRID.INFOASUNTO.HISTORIAL.VECESABIERTO' | translate}}: <b>{{correo.opens_count}}</b></p>
                          <p class="m-0 mt-10">{{'COLABORADORES.SENDGRID.INFOASUNTO.HISTORIAL.ULTIMOEVENTO' | translate}}: <b>{{correo.last_event_time | date:"d MMM y H:mm": datosEmpresaProducto.offsetPipe : idiomaActual}} ({{correo.last_event_time |date:'O': datosEmpresaProducto.offsetPipe : idiomaActual}})</b></p>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start center" class="status">
                          <button mat-mini-fab [ngClass]="{'undone':correo.status != 'delivered', 'done':correo.status == 'delivered'}">
                            <ng-container [ngSwitch]="correo.status">
                              <mat-icon *ngSwitchCase="'delivered'">done</mat-icon>
                              <mat-icon *ngSwitchDefault>more_horiz</mat-icon>
                            </ng-container>
                          </button>
                          <p class="m-0 mt-10">
                            <ng-container [ngSwitch]="correo.status">
                              <em *ngSwitchCase="'delivered'">{{'COLABORADORES.SENDGRID.INFOASUNTO.HISTORIAL.STATUS.ABIERTO' |  translate}}</em>
                              <em *ngSwitchDefault>{{'COLABORADORES.SENDGRID.INFOASUNTO.HISTORIAL.STATUS.NOENVIADO' |  translate}}</em>
                            </ng-container>
                          </p>
                        </div>
                      </div>
                    </div>
                  </mat-list-item>
                  <mat-divider *ngIf="!last"></mat-divider>
                </ng-container>
              </mat-list>
            </ng-container>
            <ng-template #sinCorreos>
              <div class="alert">
                <strong>{{'COLABORADORES.SENDGRID.INFOASUNTO.HISTORIAL.NORECORDS' | translate}}</strong>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
    </mat-step>
  </mat-horizontal-stepper>


</div>
